import { setBodyBusy } from 'helpers/uiHelpers';
import { states } from 'merica';
import React, {
	useEffect,useReducer
} from 'react';

import ShippingModal from '../shippingModal';
import {
	Button,
	FlexWrapper,
	SectionWrapper,
} from './styles';

const reducer = (prevState, newState) => (
	{
		...prevState,
		...newState,
	}
);

const Shipping = ({
	activeSection, section, setSection, token, patient, scrollToSection,
}) => {
	const [state, setState] = useReducer(reducer,
		{
			fullname: (patient && patient.shipping && patient.shipping.name) || '',
			address1: (patient && patient.shipping && patient.shipping.address1) || '',
			address1_error: false,
			address2: (patient && patient.shipping && patient.shipping.address2) || '',
			address2_error: false,
			city: (patient && patient.shipping && patient.shipping.city) || '',
			state: (patient && patient.shipping && patient.shipping.state) || '',
			zip: (patient && patient.shipping && patient.shipping.zip) || '',
			submitted: false,
			loading: false,
			blank: false,
			verified_address: {},
			original_address: {},
			allow_unverified: false, // Allow bypass of Lob address verification (on retry)
			modal: false,
		});

	useEffect(() => {
		if (patient && patient.firstname && patient.lastname) {
			setState({ ...{ fullname: `${patient.firstname} ${patient.lastname}` } });
		}
	},
	[patient])

	useEffect(() => {
		// Reset the allow_unverified flag on any address change
		// -> will bypass the Lob verification only if re-submitting the same address without change
		if (state.allow_unverified) {
			setState({ ...{ allow_unverified: false } });
		}
	},
	[state.verified_address, state.address1, state.address2, state.city, state.state, state.zip])

	const handleChange = (e) => {
		const {
			name, value,
		} = e.target;
		const tempState = {};
		tempState[name] = value;
		setState({ ...tempState });
	};

	const handleEdit = () => {
		setSection(section);
		setState({
			submitted: false,
		});
	}

	async function handleShippingModal(address_type) {
		if (document && window) {
			document.body.style.overflow = 'scroll';
		}
		if (address_type === 'verified') {
			saveShippingInfo(state.verified_address)
		} else {
			saveShippingInfo(state.original_address)
		}
		setState({ ...{ modal: false } });
	}

	async function saveShippingInfo(shippingInfo) {
		setState({ ...{ errorValue: '' } });
		setBodyBusy(true);
		try {
			const formdata = {
				patient_id: patient.id,
				shipping: shippingInfo,
				verified: true,
			}
			const res = await fetch('/ajax/patient/shipping/save/',
				{
					method: 'POST',
					body: JSON.stringify(formdata),
					contentType: 'application/json',
					dataType: 'json',
					headers: {
						'X-CSRFToken': token,
					},
				});
			const {
				error, response,
			} = await res.json();
			if (error) {
				throw new Error(error);
			}
			setState({
				...{
					submitted: true,
					loading: false,
				},
			});
			setSection(section + 1);
			setBodyBusy(false);
			scrollToSection('payment');
		} catch (error) {
			console.error(`We have an error: ${error}`);
			setState({
				...{
					loading: false,
					errorValue: error,
				},
			});
			setBodyBusy(false);
		}
	}

	async function submitForm() {
		setState({
			...{
				errorValue: '',
				address1_error: false,
				address2_error: false,
			},
		});
		if (!state.loading) {
			if (state.address1 === '' || state.city === '' || state.fullname === '' || state.state === '' || state.zip === '') {
				setState({
					...{
						errorValue: 'Please fill out all fields',
						blank: true,
					},
				});
			} else {
				setBodyBusy(true);
				setState({ ...{ loading: true } });

				if (!token) {
					console.error('No token available');
					setState({ errorValue: 'Oops, we\'re current experiencing technical difficulties. Please refresh the page and try again. If the issue persists, please contact care@apostrophe.com. Thank you.' });
					return
				}
				try {
					const formdata = {
						patient_id: patient.id,
						shipping: {
							address1: state.address1,
							address2: state.address2,
							name: state.fullname,
							city: state.city,
							state: state.state,
							zip: state.zip,
						},
					}
					if (state.allow_unverified) {
						formdata.allow_unverified = true; // Allow patient to bypass Lob verification by re-submitting
					}
					const res = await fetch('/ajax/patient/shipping/checkout/verify/',
						{
							method: 'POST',
							body: JSON.stringify(formdata),
							contentType: 'application/json',
							dataType: 'json',
							headers: {
								'X-CSRFToken': token,
							},
						});
					const {
						error, response,
					} = await res.json();
					if (error) {
						if (response && response.details &&
                (response.details['shipping.address1'] || response.details['shipping.address2'])) {
							const state_update = { loading: false };
							if (response && response.allow_unverified) {
								state_update.allow_unverified = true;
							}
							// Specific error with address
							if (response.details['shipping.address1']) {
								state_update.address1_error = response.details['shipping.address1'];
								// setState({ ...{ address1_error: response.details['shipping.address1'], loading: false } });
							} else if (response.details['shipping.address2']) {
								state_update.address2_error = response.details['shipping.address2'];
								// setState({ ...{ address2_error: response.details['shipping.address2'], loading: false } });
							}
							setState({ ...state_update });
							setBodyBusy(false);
						} else {
							if (response && response.allow_unverified) {
								setState({ ...{ allow_unverified: true } });
							}
							throw new Error(error);
						}
					} else if (response.diff_address_fields && response.diff_address_fields.length) {
						// Launch the verification modal
						setState({
							...{
								verified_address: response.verified_address,
								original_address: response.original_address,
								modal: true,
							},
						});
						setBodyBusy(false);
					} else if (response.verified_address) {
						// Save the shipping address to the patient and move forward
						saveShippingInfo(response.verified_address);
					}
				} catch (error) {
					console.error(`We have an error: ${error}`);
					setState({
						...{
							loading: false,
							errorValue: error.toString(),
						},
					});
					setBodyBusy(false);
				}
			}
		}
	}

	return (
		<SectionWrapper activeSection={activeSection} section={1}>
			<ShippingModal
				show={state.modal}
				verified_address={state.verified_address}
				original_address={state.original_address}
				saveShippingInfo={handleShippingModal}
			/>
			<h3>2 of 3</h3>
			<h1>Shipping</h1>
			<h5 onClick={handleEdit}>EDIT</h5>
			{state.submitted && <div>
				<h2>{state.fullname}</h2>
				<h2>{state.address1} {state.address2}</h2>
				<h2>{state.city}, {state.state}</h2>
				<h2>{state.zip}</h2>
			</div>}
			<div className="content">
				<div className="form-group">
					<input onChange={handleChange} id="fullname" type="text" name="fullname" value={state.fullname} required/>
					<label htmlFor="firstname">Full Name</label>
				</div>
				<div className="form-group">
					<input onChange={handleChange} id="address1" type="text" name="address1" value={state.address1} required/>
					<label value={state.lastname} htmlFor="lastname">Address Line 1</label>
					{state.address1_error && <h2 className="error" style={{ cursor: 'pointer' }}>{state.address1_error}</h2>}
				</div>
				<div className="form-group">
					<input onChange={handleChange} id="address2" type="text" name="address2" value={state.address2} required/>
					<label htmlFor="email">Address Line 2</label>
					{state.address2_error && <h2 className="error" style={{ cursor: 'pointer' }}>{state.address2_error}</h2>}
				</div>
				<div className="form-group">
					<input onChange={handleChange} id="city" type="text" name="city" value={state.city} required/>
					<label htmlFor="email">City</label>
				</div>
				<FlexWrapper>
					<div className="form-group">
						<select
							onChange={handleChange}
							value={state.state}
							id="state"
							name="state"
						>
							<option value="">State</option>
							{states.map((item, idx) => (
								<option
									key={idx}
									value={item.abbreviation}
								>
									{item.fullName}
								</option>
							))}
						</select>
					</div>
					<div className="form-group">
						<input onChange={handleChange} id="zip" type="text" name="zip" pattern="\d{5}(?:-\d{4})?" value={state.zip} required/>
						<label htmlFor="password">Zip Code</label>
					</div>
				</FlexWrapper>
				{state.errorValue
          && <h2 className="error" style={{ cursor: 'pointer' }}>{state.errorValue}</h2>
				}
				<Button onClick={submitForm}>
          Save & continue
				</Button>
			</div>
		</SectionWrapper>
	);
};

export default Shipping;
